import { saveAs } from 'file-saver';
import { Workbook, Worksheet } from "exceljs";
import header from "../Header";
import { ConfigTable, generaTabla } from "../generateTable";
import { styles as sg } from "../styles";
import { Usuario } from "../../../../types/admin-usuarios/Usuario";

export default async function Sentencias(data: Usuario[]){
    const workbook = new Workbook();
    const sheet = header(workbook, "Sentencias");
    let row = 3;
    if(true){
        const usuarios = data.map((item, ix) => {
            return { ...item, _id: ix + 1 }
        });
        // Juzgado, carpeta, numero, año, url , esta publicado o no
        const configA: ConfigTable = {
            columns: [
                {data: "area", title: "Juzgado", width: 110, align: "tStart"},
                {data: "folderType", title: "Carpeta", width: 20, align: "tCenter"},
                {data: null, title: "Número", render: (row: any)=> `${row.number}/${row.year}`, width: 15, align: "tCenter"},
                {data: "src", title: "Url", width: 60, align: "tStart"},
                {data: "publish", title: "Publicado", width: 10, align: "tCenter"},
            ]
        }
        vtCabecera(sheet, row, "Sentencias publicadas/No publicadas");
        row = generaTabla(usuarios, configA, sheet, row+2);
    }

    const buf = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buf]), `reporte_sentencias_${new Date().getFullYear()}.xlsx`);
}

function vtCabecera(sheet: Worksheet, row: number, title: string){
    sheet.mergeCells(row, 1, row, 4);
    const cellA = sheet.getRow(row).getCell(1);
    cellA.value = title;
    cellA.font = sg.font.tBold;
    cellA.alignment = sg.alignment.tCenter;
}

